import { FlexCenVer, FlexColCenVer } from '@/UI/styles';
import { Scrubber } from '@/UI/VideoAudio/Scrubber/Scrubber';
import { EditableTimeInput } from './EditableTimeInput';
import { FrameStepButton } from './FrameStepButton';
import { PlayPauseButton } from './PlayPauseButton';
import { SoundButton } from './SoundButton';
import type { MediaPlayerControlsProps } from './types';

const rowHeight = 24;
const scrubberRowHeight = 28;

export function FullMediaPlayerControls({
  currentTime,
  duration,
  fps,
  isPaused: paused,
  isMuted: muted,
  hasAudio,
  onTogglePlay,
  onSetTime,
  onToggleMute,
}: MediaPlayerControlsProps) {
  return (
    <FlexCenVer sx={{ justifyContent: 'space-between', height: `${rowHeight}px`, gap: 1, width: '100%' }}>
      <FlexCenVer sx={{ gap: 1 }}>
        <FrameStepButton
          direction="back"
          currentTime={currentTime}
          duration={duration}
          fps={fps}
          paused={paused}
          onTogglePlay={onTogglePlay}
          onSetTime={onSetTime}
          width={rowHeight}
          height={rowHeight}
          btnW={rowHeight}
          btnH={rowHeight}
        />
        <PlayPauseButton
          onTogglePlay={onTogglePlay}
          paused={paused}
          width={rowHeight}
          height={rowHeight}
          btnW={rowHeight}
          btnH={rowHeight}
        />
        <FrameStepButton
          direction="forward"
          currentTime={currentTime}
          duration={duration}
          fps={fps}
          paused={paused}
          onTogglePlay={onTogglePlay}
          onSetTime={onSetTime}
          width={rowHeight}
          height={rowHeight}
          btnW={rowHeight}
          btnH={rowHeight}
        />
      </FlexCenVer>

      <FlexCenVer sx={{ gap: 1 }}>
        <EditableTimeInput
          currentTime={currentTime}
          duration={duration}
          fps={fps}
          paused={paused}
          onTogglePlay={onTogglePlay}
          onSetTime={onSetTime}
        />
      </FlexCenVer>

      <FlexColCenVer sx={{ flex: 1, height: `${scrubberRowHeight}px`, alignItems: 'center' }}>
        <Scrubber duration={duration} setTime={onSetTime} time={currentTime} />
      </FlexColCenVer>

      <SoundButton onToggleMute={onToggleMute} hasAudio={hasAudio} muted={muted} btnW={rowHeight} btnH={rowHeight} />
    </FlexCenVer>
  );
}
